<template>
  <div>
    <el-table :data="smplForm.smpl_mtrl_list" border @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="48"></el-table-column>
      <el-table-column align="center" label="序号" width="60">
        <template v-slot="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="物料编号" show-overflow-tooltip width="150px">
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_no'" :rules="[{ required: true }]" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_no" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_no"
                :disabled="true"
                maxlength="10"
                placeholder="暂无物料编号"
                show-word-limit
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="物料名称" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_name'" :rules="[{ required: true }]" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_name" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_name"
                :disabled="true"
                maxlength="30"
                placeholder="暂无物料名称"
                show-word-limit
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="物料成分" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_comp'" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_comp" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_comp"
                :disabled="true"
                maxlength="50"
                placeholder="暂无物料成分"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="克重图片" width="100px">
        <template v-slot="scope">
          <div v-if="scope.row.gram_weight_url">
            <el-image
              :preview-src-list="[scope.row.gram_weight_url]"
              :src="scope.row.gram_weight_url"
              class="vd_elimg"
              fit="fill"
            ></el-image>
          </div>
          <span v-else class="vg_9f9a9a">暂无</span>
        </template>
      </el-table-column>
      <el-table-column label="物料使用部位" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.part_used'" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].part_used" class="item" effect="light" placement="top">
              <el-input v-model="smplForm.smpl_mtrl_list[scope.$index].part_used" maxlength="30" placeholder="暂无物料使用部位"></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <!-- 供应商列使用点击弹窗展示补充信息 -->
      <el-table-column label="供应商" prop="supp_name">
        <template v-slot="scope">
          <div class="supplier-popover-cell" @click.stop>
            <span :title="formatSupplierDisplay(scope.row)" class="supplier-popover-text">{{ formatSupplierDisplay(scope.row) }}</span>
            <el-popover
              :ref="'supplierPopover' + scope.$index"
              placement="bottom"
              trigger="click"
              width="300"
              @hide="closeSupplierPopover()"
              @show="openSupplierPopover(scope.$index)"
            >
              <div class="supplier-popover-panel">
                <div class="supplier-popover-line">
                  <span class="supplier-popover-label">供应商全称:</span>
                  <span class="supplier-popover-value">{{ scope.row.supp_name || '待补充' }}</span>
                </div>
                <div class="supplier-popover-line">
                  <span class="supplier-popover-label">联系人:</span>
                  <span class="supplier-popover-value">{{ scope.row.liaison_name || '待补充' }}</span>
                </div>
                <div class="supplier-popover-line">
                  <span class="supplier-popover-label">联系电话:</span>
                  <span class="supplier-popover-value">{{ scope.row.liaison_tel || '待补充' }}</span>
                </div>
              </div>
              <el-link
                slot="reference"
                :underline="false"
                class="supplier-popover-trigger"
                icon="el-icon-caret-bottom"
                type="info"
              ></el-link>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="面料编号" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].fabric_number || ''" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].fabric_number"
                disabled
                maxlength="30"
                placeholder="暂无面料编号"
                show-word-limit
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="物料类型" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_type'" :rules="[{ required: true }]" label-width="0">
            <el-input
              v-if="smplForm.smpl_mtrl_list[scope.$index].mtrl_type === 0"
              v-model="mtrlType1"
              :disabled="true"
              placeholder="暂无物料名称"
              show-word-limit
            ></el-input>
            <el-input
              v-else-if="smplForm.smpl_mtrl_list[scope.$index].mtrl_type === 1"
              v-model="mtrlType2"
              :disabled="true"
              placeholder="暂无物料名称"
              show-word-limit
            ></el-input>
            <el-input
              v-else-if="smplForm.smpl_mtrl_list[scope.$index].mtrl_type === 2"
              v-model="mtrlType3"
              :disabled="true"
              placeholder="暂无物料名称"
              show-word-limit
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="规格" show-overflow-tooltip show-word-limit>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_spec'" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_spec" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_spec"
                :disabled="true"
                maxlength="50"
                placeholder="暂无规格"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="潘通色号" show-overflow-tooltip width="90px">
        <!--        <template v-slot="scope">-->
        <!--          <el-form-item label-width="0" :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_color'">-->
        <!--            <el-tooltip class="item" effect="light" :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_color" placement="top">-->
        <!--              <el-input-->
        <!--                :disabled="true"-->
        <!--                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_color"-->
        <!--                maxlength="20"-->
        <!--                show-word-limit-->
        <!--                placeholder="暂无颜色"-->
        <!--              ></el-input>-->
        <!--            </el-tooltip>-->
        <!--          </el-form-item>-->
        <!--        </template>-->
        <template slot-scope="scope">
          <div v-if="scope.row.mtrl_color">
            <div class="vd_dis">
              <div :class="{ vd_div: scope.row.colr_html }" :style="{ 'background-color': scope.row.colr_html }"></div>
              <span>{{ scope.row.mtrl_color }}</span>
            </div>
          </div>
          <div v-else class="vg_9f9a9a">暂无</div>
        </template>
      </el-table-column>
      <el-table-column label="克重" show-overflow-tooltip width="60px">
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_weight'" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_weight + ''" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_weight"
                :disabled="true"
                maxlength="8"
                placeholder="暂无克重"
                show-word-limit
                @blur="
                  smplForm.smpl_mtrl_list[scope.$index].mtrl_weight = helper.retain(smplForm.smpl_mtrl_list[scope.$index].mtrl_weight, 2)
                "
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="门幅" show-overflow-tooltip width="60px">
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_width'" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_width + ''" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_width"
                :disabled="true"
                maxlength="6"
                placeholder="暂无门幅"
                show-word-limit
                @blur="
                  smplForm.smpl_mtrl_list[scope.$index].mtrl_width = helper.retain(smplForm.smpl_mtrl_list[scope.$index].mtrl_width, 2)
                "
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="毛高(毫米)" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_thick'" label-width="0">
            <el-tooltip :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_thick + ''" class="item" effect="light" placement="top">
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_thick"
                :disabled="true"
                maxlength="6"
                placeholder="暂无毛高"
                show-word-limit
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column label="库位" show-overflow-tooltip width="60px">
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.qrcd_bin_list'" label-width="0">
            <el-tooltip
              :content="smplForm.smpl_mtrl_list[scope.$index].qrcd_bin_list ? smplForm.smpl_mtrl_list[scope.$index].qrcd_bin_list + '' : ''"
              class="item"
              effect="light"
              placement="top"
            >
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].qrcd_bin_list"
                :disabled="true"
                maxlength="6"
                placeholder="暂无库位"
                show-word-limit
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="库存数" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mstk_num'" label-width="0">
            <el-tooltip
              :content="smplForm.smpl_mtrl_list[scope.$index].mstk_num ? smplForm.smpl_mtrl_list[scope.$index].mstk_num + '' : ''"
              class="item"
              effect="light"
              placement="top"
            >
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mstk_num"
                :disabled="true"
                maxlength="6"
                placeholder="暂无库存数"
                show-word-limit
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column width="200px">
        <template slot="header">
          <span>剪料长宽</span>
        </template>
        <template v-slot="scope">
          <div v-if="scope.row.mtrl_type !== 1">
            <span v-if="scope.row.smplMtrlLenWidList">
              <span v-if="clearFlag">
                <el-tag
                  v-for="(item, index) in scope.row.smplMtrlLenWidList"
                  :key="index"
                  :closable="item.closableFlag && !isShow"
                  :disabled="isShow"
                  class="elTagItem"
                  @close="handleClose(scope.$index, index)"
                  >{{ item.label }}</el-tag
                >
              </span>
            </span>
            <span v-if="scope.row.mtrl_type == '0'">
              <el-button class="el-icon-plus vg_pointer circle" plain plian @click="addTag(scope.$index, index)"></el-button>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" show-overflow-tooltip>
        <template slot="header">
          <span>状态</span>
        </template>
        <template v-slot="scope">
          <div v-if="smplForm.smpl_mtrl_list[scope.$index].mstk_num">
            <el-tag v-if="!smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_status">未出库</el-tag>
            <div v-else>
              <el-tag v-if="scope.row.smpl_mtrl_status === 0">未出库</el-tag>
              <el-tag v-else type="success">已出库{{ scope.row.smpl_mtrl_status }}次</el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="单位" show-overflow-tooltip width="50px">
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_unit'" :rules="[{ required: true }]" label-width="1000">
            <el-tooltip
              :content="smplForm.smpl_mtrl_list[scope.$index].mtrl_unit ? smplForm.smpl_mtrl_list[scope.$index].mtrl_unit + '' : ''"
              class="item"
              effect="light"
              placement="top-start"
            >
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_unit"
                :disabled="true"
                maxlength="9"
                placeholder="暂无单位"
                show-word-limit
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="用量" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.smpl_mtrl_consume'" label-width="0">
            <el-tooltip
              :content="
                smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_consume ? smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_consume + '' : ''
              "
              class="item"
              effect="light"
              placement="top-start"
            >
              <el-input
                v-model="scope.row.smpl_mtrl_consume"
                maxlength="9"
                placeholder="暂无用量"
                show-word-limit
                @blur="scope.row.smpl_mtrl_consume = helper.calcPrice(scope.row.smpl_mtrl_consume, 4, 10000)"
                @change="totalPriceChange(scope.$index)"
                @input="scope.row.smpl_mtrl_consume.smpl_mtrl_consume = helper.keepTNum1(scope.row.smpl_mtrl_consume)"
              />
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="单价" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.mtrl_prod_price'" label-width="0">
            <el-tooltip
              :content="
                smplForm.smpl_mtrl_list[scope.$index].mtrl_prod_price ? smplForm.smpl_mtrl_list[scope.$index].mtrl_prod_price + '' : ''
              "
              class="item"
              effect="light"
              placement="top"
            >
              <el-input
                v-model="smplForm.smpl_mtrl_list[scope.$index].mtrl_prod_price"
                :disabled="true"
                maxlength="6"
                placeholder="暂无单价"
                show-word-limit
                @change="totalPriceChange(scope.$index)"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <!-- <el-table-column show-overflow-tooltip>
        <template slot="header">
          <span>剪料单位</span>
        </template>
        <template>
          <el-input size="mini" :disabled="true" value="厘米"></el-input>
        </template>
      </el-table-column> -->
      <!-- <el-table-column show-overflow-tooltip label="损耗比率">
        <template v-slot="scope">
          <el-form-item
            label-width="0"
            :prop="'smpl_mtrl_list.' + scope.$index + '.smpl_mtrl_loss'"
          >
            <el-tooltip
              class="item"
              effect="light"
              :content="
                smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss
                  ? smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss + ''
                  : ''
              "
              placement="top-start"
            >
              <el-input
              v-if="smplForm.smpl_mtrl_list[scope.$index].mtrl_type === 0"
                show-word-limit
                maxlength="9"
                v-model="
                  smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss
                "
                @input="
                  smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss =
                    helper.keepTNum1(
                      smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss
                    )
                "
                @blur="smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss=helper.retain1(smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss,2,1000000)"
                @change="lossChange(smplForm.smpl_mtrl_list[scope.$index].smpl_mtrl_loss,scope.$index)"
                placeholder="暂无损耗比率"
              ></el-input>
              <el-input
              v-if="smplForm.smpl_mtrl_list[scope.$index].mtrl_type !== 0"
                show-word-limit
                maxlength="9"
                disabled
                v-model="
                  valueType
                "
                placeholder="暂无损耗比率"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column> -->
      <el-table-column label="金额" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'smpl_mtrl_list.' + scope.$index + '.totalChange'" label-width="0">
            <el-input
              v-model="smplForm.smpl_mtrl_list[scope.$index].totalChange"
              disabled
              maxlength="9"
              placeholder="暂无金额"
              show-word-limit
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :before-close="handelClose" :visible.sync="dialogVisible" title="提示:请输入物料长度和物料宽度" width="45%">
      <el-row>
        <el-form>
          <el-col :md="11">
            <el-form-item label="长：" label-width="60px">
              <el-input
                v-model="value"
                maxlength="7"
                show-word-limit
                @change="value = helper.retain1(value, 2, 10000)"
                @input="value = helper.keepTNum1(value)"
              >
                <template slot="append">厘米</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="2" class="vd_center">*</el-col>
          <el-col :md="11">
            <el-form-item label="宽：" label-width="60px">
              <el-input
                v-model="value2"
                maxlength="7"
                show-word-limit
                @change="value2 = helper.retain1(value2, 2, 10000)"
                @input="value2 = helper.keepTNum1(value2)"
              >
                <template slot="append">厘米</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="detClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SmplEditBomChild',
  props: {
    smplForm: {
      type: Object,
      required: true
    },
    mtrlTypeGroupOpt: {
      type: Array,
      required: true
    },
    isShow: {
      type: Boolean
    }
  },
  data() {
    return {
      selectionsList: [],
      mtrlType: [
        { id: 0, label: '原面料' },
        { id: 1, label: '辅料' },
        { id: 2, label: '包材' }
      ],
      mtrlType1: '原面料',
      mtrlType2: '辅料',
      mtrlType3: '包材',
      dialogVisible: false,
      rowIndex: null,
      index: '',
      value: '', //新增剪料 第一个输入框
      value2: '', //新增剪料第二个输入框
      clearFlag: true,
      valueType: '暂无',
      // 记录当前打开的供应商弹窗行，便于滚动时直接关闭
      activeSupplierPopoverIndex: null
    };
  },
  created() {
    this.initData();
  },
  beforeDestroy() {
    this.closeSupplierPopover();
  },
  methods: {
    initData() {},
    formatSupplierDisplay(row) {
      return `${row.supp_name || '暂无'}（供应商全称）${row.liaison_name || '暂无'}（联系人）${row.liaison_tel || '暂无'}（联系电话）`;
    },
    // 打开弹窗后监听滚动和窗口变化，避免弹层与单元格位置错位
    openSupplierPopover(index) {
      this.activeSupplierPopoverIndex = index;
      document.addEventListener('scroll', this.closeSupplierPopover, true);
      window.addEventListener('resize', this.closeSupplierPopover);
    },
    // 页面一旦滚动或销毁组件时，直接关闭当前弹窗
    closeSupplierPopover() {
      if (this.activeSupplierPopoverIndex === null) return;
      const popover = this.$refs['supplierPopover' + this.activeSupplierPopoverIndex];
      const popoverInstance = Array.isArray(popover) ? popover[0] : popover;
      if (popoverInstance && typeof popoverInstance.doClose === 'function') {
        popoverInstance.doClose();
      }
      this.activeSupplierPopoverIndex = null;
      document.removeEventListener('scroll', this.closeSupplierPopover, true);
      window.removeEventListener('resize', this.closeSupplierPopover);
    },
    //bom清单选择框
    handleSelectionChange(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
      this.$emit('handleSelectionChange', this.selectionsList);
    },
    handleClose(rowI, index) {
      this.clearFlag = false;
      let str = '';
      this.smplForm.smpl_mtrl_list[rowI].smplMtrlLenWidList.splice(index, 1);
      for (let i = 0; i < this.smplForm.smpl_mtrl_list[rowI].smplMtrlLenWidList.length; i++) {
        if (i === this.smplForm.smpl_mtrl_list[rowI].smplMtrlLenWidList.length - 1) {
          str = str + this.smplForm.smpl_mtrl_list[rowI].smplMtrlLenWidList[i].label;
        } else {
          str = str + this.smplForm.smpl_mtrl_list[rowI].smplMtrlLenWidList[i].label + ',';
        }
      }
      this.smplForm.smpl_mtrl_list[rowI].smpl_mtrl_len_wid = str;
      this.$nextTick(() => {
        this.clearFlag = true;
      });
    },
    addTag(rowIndex, index) {
      this.rowIndex = rowIndex;
      this.index = index;
      this.dialogVisible = true;
    },
    // 损耗比率改变
    // lossChange(val,val1){
    //   if(!val){
    //     this.smplForm.smpl_mtrl_list[val1].smpl_mtrl_loss = '1.03'
    //   }
    //   this.totalPriceChange(val1)
    // },
    // 计算总金额
    totalPriceChange(scope) {
      this.$emit('priceChange', scope);
    },
    //关闭 dialog
    handelClose() {
      this.value = '';
      this.value2 = '';
      this.dialogVisible = false;
    },
    detClick() {
      if (this.value == '' || this.value2 == '') {
        return this.$message.warning('长和宽不可以为空');
      }
      if (this.value == '0.00' || this.value2 == '0.00') {
        return this.$message.warning('长和宽不可以为0');
      }
      let temp = false;
      let temp1 = false;
      let temp2 = false;
      let temp3 = false;
      if (
        this.value > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mtrl_width) * 100 &&
        this.value2 > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mtrl_width) * 100
      ) {
        temp = true;
      }
      if (
        this.value > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mstk_num) * 100 &&
        this.value2 > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mstk_num) * 100
      ) {
        temp1 = true;
      }
      if (
        this.value > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mtrl_width) * 100 &&
        this.value > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mstk_num) * 100
      ) {
        temp2 = true;
      }
      if (
        this.value2 > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mtrl_width) * 100 &&
        this.value2 > Number(this.smplForm.smpl_mtrl_list[this.rowIndex].mstk_num) * 100
      ) {
        temp3 = true;
      }
      if (temp || temp1 || temp2 || temp3) {
        return this.$message.warning('剪料长和宽不能同时超过物料门幅和库存数');
      }
      if (!this.smplForm.smpl_mtrl_list[this.rowIndex].smpl_mtrl_len_wid) {
        this.$set(this.smplForm.smpl_mtrl_list[this.rowIndex], 'smpl_mtrl_len_wid', '');
      } else {
        this.smplForm.smpl_mtrl_list[this.rowIndex].smpl_mtrl_len_wid += ',';
      }
      this.clearFlag = false;
      this.$forceUpdate();
      let newValue = this.value + '*' + this.value2;
      let tempList = {};
      tempList.key = this.smplForm.smpl_mtrl_list[this.rowIndex].smplMtrlLenWidList.length;
      tempList.label = newValue;
      tempList.closableFlag = true;
      this.smplForm.smpl_mtrl_list[this.rowIndex].smplMtrlLenWidList.push(tempList);
      let str = '';
      for (let i = 0; i < this.smplForm.smpl_mtrl_list[this.rowIndex].smplMtrlLenWidList.length; i++) {
        if (i === this.smplForm.smpl_mtrl_list[this.rowIndex].smplMtrlLenWidList.length - 1) {
          str = str + this.smplForm.smpl_mtrl_list[this.rowIndex].smplMtrlLenWidList[i].label;
        } else {
          str = str + this.smplForm.smpl_mtrl_list[this.rowIndex].smplMtrlLenWidList[i].label + ',';
        }
      }
      this.smplForm.smpl_mtrl_list[this.rowIndex].smpl_mtrl_len_wid = str;
      this.value = '';
      this.value2 = '';
      this.dialogVisible = false;
      this.$nextTick(() => {
        this.clearFlag = true;
      });
    }
  }
};
</script>

<style scoped>
.circle {
  background-color: #c4bcbc;
  border-radius: 50%;
  padding: 2px;
  border: 0;
  color: #fff;
}
.elTagItem {
  padding: 0 2px;
  margin-right: 2px;
  height: 24px;
  line-height: 24px;
}
.vd_center {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 24px;
}
.vd_dis {
  display: flex;
}
.vd_div {
  width: 40px;
  height: 20px;
  border: none;
  margin-right: 5px;
}
.supplier-popover-cell {
  align-items: center;
  display: flex;
  gap: 4px;
  width: 100%;
}
.supplier-popover-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.supplier-popover-trigger {
  flex-shrink: 0;
}
.supplier-popover-panel {
  font-size: 13px;
  line-height: 20px;
}
.supplier-popover-line {
  display: flex;
}
.supplier-popover-label {
  color: #606266;
  flex-shrink: 0;
  width: 72px;
}
.supplier-popover-value {
  color: #303133;
  word-break: break-all;
}
</style>
